export const addictionMedicine = {
  onClickProps: "Addiction_Medicine",
  popularTopics: [
    {
      title: "Key resources for substance use and addictive behaviours",
      link: "/viewTopic?etgAccess=true&guidelinePage=Addiction%20Medicine&topicfile=c_AMG_Key-resources-for-substance-use-and-addictive-behaviours_topic_1&guidelinename=auto&sectionId=c_AMG_Key-resources-for-substance-use-and-addictive-behaviours_topic_1#c_AMG_Key-resources-for-substance-use-and-addictive-behaviours_topic_1",
    },
    {
      title: "Gambling",
      link: "/viewTopic?etgAccess=true&guidelinePage=Addiction%20Medicine&topicfile=c_AMG_Gambling_topic_1&guidelinename=auto&sectionId=c_AMG_Gambling_topic_1#c_AMG_Gambling_topic_1",
    },
    {
      title: "Gaming",
      link: "/viewTopic?etgAccess=true&guidelinePage=Addiction%20Medicine&topicfile=c_AMG_Gaming_topic_1&guidelinename=auto&sectionId=c_AMG_Gaming_topic_1#c_AMG_Gaming_topic_1",
    },
    {
      title: "Overview of substance use and addictive behaviours",
      link: "/viewTopic?etgAccess=true&guidelinePage=Addiction%20Medicine&topicfile=c_AMG_Overview-of-substance-use-and-addictive-behaviours_topic_1&guidelinename=auto&sectionId=c_AMG_Overview-of-substance-use-and-addictive-behaviours_topic_1#c_AMG_Overview-of-substance-use-and-addictive-behaviours_topic_1",
    },
    {
      title: "Opioids: hazardous, harmful and dependent use",
      link: "/viewTopic?etgAccess=true&guidelinePage=Addiction%20Medicine&topicfile=c_AMG_Opioids-hazardous-harmful-and-dependent-use_topic_1&guidelinename=auto&sectionId=c_AMG_Opioids-hazardous-harmful-and-dependent-use_topic_1#c_AMG_Opioids-hazardous-harmful-and-dependent-use_topic_1",
    },
  ],
};

export const antibiotic = {
  onClickProps: "Antibiotic",
  popularTopics: [
    {
      title:
        "Managing suspected infection with a multidrug-resistant gram-negative bacterium",
      link: "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=c_ABG_Managing-suspected-infection-with-a-multidrug-resistant-Gram-negative-bacterium_topic_1&guidelinename=auto&sectionId=c_ABG_Managing-suspected-infection-with-a-multidrug-resistant-Gram-negative-bacterium_topic_1#c_ABG_Managing-suspected-infection-with-a-multidrug-resistant-Gram-negative-bacterium_topic_1",
    },
    {
      title: "Protracted bacterial bronchitis in children",
      link: "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=protracted-bacterial-bronchitis&guidelinename=Antibiotic&sectionId=toc_d1e47#toc_d1e47",
    },
    {
      title: "Monitoring antimicrobial blood concentrations",
      link: "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=c_ABG_Monitoring-antimicrobial-blood-concentrations_topic_1&guidelinename=auto&sectionId=c_ABG_Monitoring-antimicrobial-blood-concentrations_topic_1#c_ABG_Monitoring-antimicrobial-blood-concentrations_topic_1",
    },
    {
      title: "Infections associated with intravenous catheters",
      link: "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=c_ABG17_Infections-associated-with-intravenous-catheters_topic_1&guidelinename=auto&sectionId=c_ABG17_Infections-associated-with-intravenous-catheters_topic_1#c_ABG17_Infections-associated-with-intravenous-catheters_topic_1",
    },
    {
      title: "Principles of obtaining blood for culture",
      link: "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=c_ABG_Principles-of-obtaining-blood-for-culture_topic_1&guidelinename=auto&sectionId=c_ABG_Principles-of-obtaining-blood-for-culture_topic_1#c_ABG_Principles-of-obtaining-blood-for-culture_topic_1",
    },
    {
      title: "Clostridioides difficile infection",
      link: "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=c_ABG_Clostridioides-difficile-infection_topic_1&guidelinename=auto&sectionId=c_ABG_Clostridioides-difficile-infection_topic_1#c_ABG_Clostridioides-difficile-infection_topic_1",
    },
    {
      title: "Interpreting microbiological testing results",
      link: "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=c_ABG_Interpreting-microbiological-testing-results_topic_1&guidelinename=auto&sectionId=c_ABG_Interpreting-microbiological-testing-results_topic_1#c_ABG_Interpreting-microbiological-testing-results_topic_1",
    },
    {
      title:
        "Vancomycin dosing, monitoring and dosage adjustment in adults undergoing dialysis",
      link: "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=c_ABG_Vancomycin-dosing-monitoring-and-dosage-adjustment-in-adults-undergoing-dialysis_topic_1&guidelinename=auto&sectionId=c_ABG_Vancomycin-dosing-monitoring-and-dosage-adjustment-in-adults-undergoing-dialysis_topic_1#c_ABG_Vancomycin-dosing-monitoring-and-dosage-adjustment-in-adults-undergoing-dialysis_topic_1",
    },
    {
      title: "Trimethoprim+sulfamethoxazole hypersensitivity in adults",
      link: "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=c_ABG_Trimethoprim_sulfamethoxazole-hypersensitivity-in-adults_topic_1&guidelinename=auto&sectionId=c_ABG_Trimethoprim_sulfamethoxazole-hypersensitivity-in-adults_topic_1#c_ABG_Trimethoprim_sulfamethoxazole-hypersensitivity-in-adults_topic_1",
    },
  ],
};

export const boneandmetabolism = {
  onClickProps: "Bone_and_Metabolism",
  popularTopics: [
    {
      title: "Hypophosphataemia",
      link: "/viewTopic?etgAccess=true&guidelinePage=Bone%20and%20Metabolism&topicfile=hypophosphataemia",
    },
    {
      title: "Osteoporosis and minimal trauma fracture",
      link: "/viewTopic?etgAccess=true&guidelinePage=Bone%20and%20Metabolism&topicfile=osteoporosis-minimal-trauma-fracture",
    },
    {
      title: "Adrenocortical suppression",
      link: "/viewTopic?etgAccess=true&guidelinePage=Bone%20and%20Metabolism&topicfile=adrenocortical-suppression",
    },
    {
      title: "Primary aldosteronism",
      link: "/viewTopic?etgAccess=true&guidelinePage=Bone%20and%20Metabolism&topicfile=primary-aldosteronism",
    },
    {
      title: "Hypopituitarism",
      link: "/viewTopic?etgAccess=true&guidelinePage=Bone%20and%20Metabolism&topicfile=hypopituitarism",
    },
  ],
};

export const cardiovascular = {
  onClickProps: "Cardiovascular",
  popularTopics: [
    {
      title: "Peripheral artery disease",
      link: "/viewTopic?etgAccess=true&guidelinePage=Cardiovascular&topicfile=c_CVG_Peripheral-artery-diseasetopic_1&guidelinename=auto&sectionId=c_CVG_Peripheral-artery-diseasetopic_1#c_CVG_Peripheral-artery-diseasetopic_1",
    },
    {
      title: "Orthostatic hypotension",
      link: "/viewTopic?etgAccess=true&guidelinePage=Cardiovascular&topicfile=c_CVG_Orthostatic-hypotensiontopic_1&guidelinename=auto&sectionId=c_CVG_Orthostatic-hypotensiontopic_1#c_CVG_Orthostatic-hypotensiontopic_1",
    },
    {
      title: "Urgent control of elevated blood pressure",
      link: "/viewTopic?etgAccess=true&guidelinePage=Cardiovascular&topicfile=c_CVG_Urgent-control-of-elevated-blood-pressuretopic_1&guidelinename=auto&sectionId=c_CVG_Urgent-control-of-elevated-blood-pressuretopic_1#c_CVG_Urgent-control-of-elevated-blood-pressuretopic_1",
    },
    {
      title: "Cardiac rehabilitation programs",
      link: "/viewTopic?etgAccess=true&guidelinePage=Cardiovascular&topicfile=cardiac-rehabilitation-programs&guidelinename=Cardiovascular&sectionId=toc_d1e47#toc_d1e47",
    },
    {
      title:
        "Periprocedural management of patients with cardiovascular disease",
      link: "/viewTopic?etgAccess=true&guidelinePage=Cardiovascular&topicfile=c_CVG_Periprocedural-management-of-patients-with-cardiovascular-diseasetopic_1&guidelinename=auto&sectionId=c_CVG_Periprocedural-management-of-patients-with-cardiovascular-diseasetopic_1#c_CVG_Periprocedural-management-of-patients-with-cardiovascular-diseasetopic_1",
    },
  ],
};

export const dermatology = {
  onClickProps: "Dermatology",
  popularTopics: [
    {
      title: "Considerations in the use of topical corticosteroids",
      link: "/viewTopic?etgAccess=true&guidelinePage=Dermatology&topicfile=c_DMG_Considerations-in-the-use-of-topical-corticosteroids_topic_1&guidelinename=auto&sectionId=c_DMG_Considerations-in-the-use-of-topical-corticosteroids_topic_1#c_DMG_Considerations-in-the-use-of-topical-corticosteroids_topic_1",
    },
    {
      title: "Acne",
      link: "/viewTopic?etgAccess=true&guidelinePage=Dermatology&topicfile=c_DMG_Acne_topic_1&guidelinename=auto&sectionId=c_DMG_Acne_topic_1#c_DMG_Acne_topic_1",
    },
    {
      title: "Cutaneous drug reactions",
      link: "/viewTopic?etgAccess=true&guidelinePage=Dermatology&topicfile=c_DMG_Cutaneous-drug-reactions_topic_1&guidelinename=auto&sectionId=c_DMG_Cutaneous-drug-reactions_topic_1#c_DMG_Cutaneous-drug-reactions_topic_1",
    },
    {
      title: "Atopic dermatitis",
      link: "/viewTopic?etgAccess=true&guidelinePage=Dermatology&topicfile=c_DMG_Atopic-dermatitis_topic_1&guidelinename=auto&sectionId=c_DMG_Atopic-dermatitis_topic_1#c_DMG_Atopic-dermatitis_topic_1",
    },
    {
      title: "Tinea",
      link: "/viewTopic?etgAccess=true&guidelinePage=Dermatology&topicfile=c_DMG_Tinea_topic_1&guidelinename=auto&sectionId=c_DMG_Tinea_topic_1#c_DMG_Tinea_topic_1",
    },
    {
      title: "Head lice",
      link: "/viewTopic?etgAccess=true&guidelinePage=Dermatology&topicfile=c_DMG_Head-lice_topic_1&guidelinename=auto&sectionId=c_DMG_Head-lice_topic_1#c_DMG_Head-lice_topic_1",
    },
    {
      title: "Scabies",
      link: "/viewTopic?etgAccess=true&guidelinePage=Dermatology&topicfile=c_DMG_Scabies_topic_1&guidelinename=auto&sectionId=c_DMG_Scabies_topic_1#c_DMG_Scabies_topic_1",
    },
    {
      title: "Solar damage",
      link: "/viewTopic?etgAccess=true&guidelinePage=Dermatology&topicfile=c_DMG_Solar-damage_topic_1&guidelinename=auto&sectionId=c_DMG_Solar-damage_topic_1#c_DMG_Solar-damage_topic_1",
    },
    {
      title: "Urticaria",
      link: "/viewTopic?etgAccess=true&guidelinePage=Dermatology&topicfile=c_DMG_Urticaria_topic_1&guidelinename=auto&sectionId=c_DMG_Urticaria_topic_1#c_DMG_Urticaria_topic_1",
    },
  ],
};

export const developmentaldisability = {
  onClickProps: "Developmental_Disability",
  popularTopics: [
    {
      title: "Assessing developmental delay and disability",
      link: "/viewTopic?etgAccess=true&guidelinePage=Developmental%20Disability&topicfile=assessing-dev-delay-and-disability",
    },
    {
      title: "Communicating with a person with developmental disability",
      link: "/viewTopic?etgAccess=true&guidelinePage=Developmental%20Disability&topicfile=communicating-developmental-disability",
    },
    {
      title: "Autism spectrum disorder",
      link: "/viewTopic?etgAccess=true&guidelinePage=Developmental%20Disability&topicfile=autism-spectrum-disorder",
    },
    {
      title:
        "Role of the general practitioner in the care of a person with developmental disability",
      link: "/viewTopic?etgAccess=true&guidelinePage=Developmental%20Disability&topicfile=gp-role-developmental-disability",
    },
    {
      title:
        "Consent, capacity and decision making for people with developmental disability",
      link: "/viewTopic?etgAccess=true&guidelinePage=Developmental%20Disability&topicfile=consent-capacity-decisionmaking-developmental-disability",
    },
    {
      title: "Common health problems in people with developmental disability",
      link: "/viewTopic?etgAccess=true&guidelinePage=Developmental%20Disability&topicfile=common-health-problems-developmental-disability",
    },
    {
      title: "Challenging behaviour in a person with developmental disability",
      link: "/viewTopic?etgAccess=true&guidelinePage=Developmental%20Disability&topicfile=challenging-behaviour-developmental-disability",
    },
  ],
};

export const diabetes = {
  onClickProps: "Diabetes",
  popularTopics: [
    {
      title:
        "Screening and management of people at risk of developing type 2 diabetes",
      link: "/viewTopic?etgAccess=true&guidelinePage=Diabetes&topicfile=c_DBG_Screening-and-management-of-people-at-risk-of-developing-type-2-diabetes_topic_1&guidelinename=auto&sectionId=c_DBG_Screening-and-management-of-people-at-risk-of-developing-type-2-diabetes_topic_1#c_DBG_Screening-and-management-of-people-at-risk-of-developing-type-2-diabetes_topic_1",
    },
    {
      title: "Drug-induced hyperglycaemia",
      link: "/viewTopic?etgAccess=true&guidelinePage=Diabetes&topicfile=drug-induced-hyperglycaemia",
    },
    {
      title: "Transition of adolescents to adult diabetes management",
      link: "/viewTopic?etgAccess=true&guidelinePage=Diabetes&topicfile=transition-of-adolescents-to-adult-diabetes-management",
    },
    {
      title: "Glycaemic targets for adults with type 2 diabetes",
      link: "/viewTopic?etgAccess=true&guidelinePage=Diabetes&topicfile=c_DBG_Glycaemic-targets-for-adults-with-type-2-diabetes_topic_1&guidelinename=auto&sectionId=c_DBG_Glycaemic-targets-for-adults-with-type-2-diabetes_topic_1#c_DBG_Glycaemic-targets-for-adults-with-type-2-diabetes_topic_1",
    },
    {
      title: "Classifying and diagnosing diabetes",
      link: "/viewTopic?etgAccess=true&guidelinePage=Diabetes&topicfile=other-types-of-diabetes&guidelinename=auto&sectionId=c_classifying_diagnosing_and_screening_for_diabetes#c_classifying_diagnosing_and_screening_for_diabetes",
    },
  ],
};

export const fatigue = {
  onClickProps: "Fatigue",
  popularTopics: [
    {
      title: "Fatigue: overview",
      link: "/viewTopic?etgAccess=true&guidelinePage=Fatigue&topicfile=c_FTG_Fatigue-overviewtopic_1&guidelinename=auto&sectionId=c_FTG_Fatigue-overviewtopic_1#c_FTG_Fatigue-overviewtopic_1",
    },
    {
      title: "Conditions commonly associated with fatigue",
      link: "/viewTopic?etgAccess=true&guidelinePage=Fatigue&topicfile=c_FTG_Conditions-commonly-associated-with-fatiguetopic_1&guidelinename=auto&sectionId=c_FTG_Conditions-commonly-associated-with-fatiguetopic_1#c_FTG_Conditions-commonly-associated-with-fatiguetopic_1",
    },
    {
      title: "Fatigue: diagnostic process",
      link: "/viewTopic?etgAccess=true&guidelinePage=Fatigue&topicfile=c_FTG_Fatigue-diagnostic-processtopic_1&guidelinename=auto&sectionId=c_FTG_Fatigue-diagnostic-processtopic_1#c_FTG_Fatigue-diagnostic-processtopic_1",
    },
    {
      title: "Fatigue in specific age groups",
      link: "/viewTopic?etgAccess=true&guidelinePage=Fatigue&topicfile=c_FTG_Fatigue-in-specific-age-groupstopic_1&guidelinename=auto&sectionId=c_FTG_Fatigue-in-specific-age-groupstopic_1#c_FTG_Fatigue-in-specific-age-groupstopic_1",
    },
    {
      title: "Fatigue in patients with pre-existing conditions",
      link: "/viewTopic?etgAccess=true&guidelinePage=Fatigue&topicfile=c_FTG_Fatigue-in-patients-with-pre-existing-conditionstopic_1&guidelinename=auto&sectionId=c_FTG_Fatigue-in-patients-with-pre-existing-conditionstopic_1#c_FTG_Fatigue-in-patients-with-pre-existing-conditionstopic_1",
    },
    {
      title: "Persistent unexplained fatigue",
      link: "/viewTopic?etgAccess=true&guidelinePage=Fatigue&topicfile=c_FTG_Persistent-unexplained-fatiguetopic_1&guidelinename=auto&sectionId=c_FTG_Persistent-unexplained-fatiguetopic_1#c_FTG_Persistent-unexplained-fatiguetopic_1",
    },
    {
      title: "Prevalence of conditions associated with fatigue (Appendix 16.1)",
      link: "/viewTopic?etgAccess=true&guidelinePage=Fatigue&topicfile=c_FTG_Prevalence-of-conditions-associated-with-fatiguetopic_1&guidelinename=auto&sectionId=c_FTG_Prevalence-of-conditions-associated-with-fatiguetopic_1#c_FTG_Prevalence-of-conditions-associated-with-fatiguetopic_1",
    },
    {
      title: "Resources for rational testing (Appendix 16.2)",
      link: "/viewTopic?etgAccess=true&guidelinePage=Fatigue&topicfile=c_FTG_Resources-for-rational-testingtopic_1&guidelinename=auto&sectionId=c_FTG_Resources-for-rational-testingtopic_1#c_FTG_Resources-for-rational-testingtopic_1",
    },
    {
      title:
        "Worked examples estimating the post-test probability of disease (Appendix 16.3)",
      link: "/viewTopic?etgAccess=true&guidelinePage=Fatigue&topicfile=c_FTG_Worked-examples-estimating-the-post-test-probability-of-disease-Appendix-16.3topic_1&guidelinename=auto&sectionId=c_FTG_Worked-examples-estimating-the-post-test-probability-of-disease-Appendix-16.3topic_1#c_FTG_Worked-examples-estimating-the-post-test-probability-of-disease-Appendix-16.3topic_1",
    },
  ],
};

export const gastrointestinal = {
  onClickProps: "Gastrointestinal",
  popularTopics: [
    {
      title: "Iron deficiency - intravenous iron supplementation",
      link: "/viewTopic?etgAccess=true&guidelinePage=Gastrointestinal&topicfile=c_GIG_Gastro-oesophageal-reflux-in-adultstopic_1&guidelinename=auto&sectionId=c_GIG_Intravenous-iron-supplementationtopic_2#c_GIG_Intravenous-iron-supplementationtopic_2",
    },
    {
      title: "Helicobacter pylori infection",
      link: "/viewTopic?etgAccess=true&guidelinePage=Gastrointestinal&topicfile=c_GIG_Helicobacter-pylori-infectiontopic_1&guidelinename=auto&sectionId=c_GIG_Helicobacter-pylori-infectiontopic_1#c_GIG_Helicobacter-pylori-infectiontopic_1",
    },
    {
      title: "Cannabinoid hyperemesis syndrome",
      link: "/viewTopic?etgAccess=true&guidelinePage=Gastrointestinal&topicfile=c_GIG_Cannabinoid-hyperemesis-syndrometopic_1&guidelinename=auto&sectionId=c_GIG_Cannabinoid-hyperemesis-syndrometopic_1#c_GIG_Cannabinoid-hyperemesis-syndrometopic_1",
    },
    {
      title: "Opioid-induced constipation in adults",
      link: "/viewTopic?etgAccess=true&guidelinePage=Gastrointestinal&topicfile=c_GIG_Opioid-induced-constipation-in-adultstopic_1&guidelinename=auto&sectionId=c_GIG_Opioid-induced-constipation-in-adultstopic_1#c_GIG_Opioid-induced-constipation-in-adultstopic_1",
    },
    {
      title: "Small intestinal bacterial overgrowth",
      link: "/viewTopic?etgAccess=true&guidelinePage=Gastrointestinal&topicfile=c_GIG_Small-intestinal-bacterial-overgrowthtopic_1&guidelinename=auto&sectionId=c_GIG_Small-intestinal-bacterial-overgrowthtopic_1#c_GIG_Small-intestinal-bacterial-overgrowthtopic_1",
    },
  ],
};

export const liverdisorders = {
  onClickProps: "Liver_Disorders",
  popularTopics: [
    {
      title: "Hepatitis B",
      link: "/viewTopic?etgAccess=true&guidelinePage=Liver%20Disorders&topicfile=hepatitis-b",
    },
    {
      title: "Hepatitis C",
      link: "/viewTopic?etgAccess=true&guidelinePage=Liver%20Disorders&topicfile=hepatitis-c",
    },
    {
      title: "Noninvasive assessment of liver fibrosis",
      link: "/viewTopic?etgAccess=true&guidelinePage=Liver%20Disorders&topicfile=liver-fibrosis-assessment",
    },
    {
      title: "Incidental liver lesions",
      link: "/viewTopic?etgAccess=true&guidelinePage=Liver%20Disorders&topicfile=liver-lesions",
    },
    {
      title: "Drug-induced liver injury",
      link: "/viewTopic?etgAccess=true&guidelinePage=Liver%20Disorders&topicfile=drug-induced-liver-injury",
    },
  ],
};

export const neurology = {
  onClickProps: "Neurology",
  popularTopics: [
    {
      title: "Acute management of seizures and status epilepticus",
      link: "/viewTopic?etgAccess=true&guidelinePage=Neurology&topicfile=acute-management-of-seizures-and-status-epilepticus",
    },
    {
      title: "Epilepsy and seizures",
      link: "/viewTopic?etgAccess=true&guidelinePage=Neurology&topicfile=epilepsy-and-seizures",
    },
    {
      title: "Tension-type headache",
      link: "/viewTopic?etgAccess=true&guidelinePage=Neurology&topicfile=tension-type-headache",
    },
    {
      title: "Benign paroxysmal positional vertigo",
      link: "/viewTopic?etgAccess=true&guidelinePage=Neurology&topicfile=benign-paroxysmal-positional-vertigo",
    },
    {
      title: "Motion sickness",
      link: "/viewTopic?etgAccess=true&guidelinePage=Neurology&topicfile=motion-sickness",
    },
  ],
};
export const oralanddental = {
  onClickProps: "Oral_and_Dental",
  popularTopics: [
    {
      title: "Tooth fractures",
      link: "/viewTopic?etgAccess=true&guidelinePage=Oral%20and%20Dental&topicfile=c_DTG_Tooth-fractures_topic_1&guidelinename=auto&sectionId=c_DTG_Tooth-fractures_topic_1#c_DTG_Tooth-fractures_topic_1",
    },
    {
      title: "Injuries that cause displacement of teeth (luxation injuries)",
      link: "/viewTopic?etgAccess=true&guidelinePage=Oral%20and%20Dental&topicfile=c_DTG_Injuries-that-cause-displacement-of-teeth-luxation-injuries_topic_1&guidelinename=auto&sectionId=c_DTG_Injuries-that-cause-displacement-of-teeth-luxation-injuries_topic_1#c_DTG_Injuries-that-cause-displacement-of-teeth-luxation-injuries_topic_1",
    },
    {
      title:
        "Guidance for medical practitioners managing oral and dental issues; dental anatomy and terminology and dental numbering",
      link: "/viewTopic?etgAccess=true&guidelinePage=Oral%20and%20Dental&topicfile=c_DTG_Guidance-for-medical-practitioners-managing-oral-and-dental-issues_topic_1&guidelinename=auto&sectionId=c_DTG_Guidance-for-medical-practitioners-managing-oral-and-dental-issues_topic_1#c_DTG_Guidance-for-medical-practitioners-managing-oral-and-dental-issues_topic_1",
    },
    {
      title: "Kidney failure (end-stage kidney disease): dental considerations",
      link: "/viewTopic?etgAccess=true&guidelinePage=Oral%20and%20Dental&topicfile=c_DTG_Kidney-failure-end-stage-kidney-disease-dental-considerations_topic_1&guidelinename=auto&sectionId=c_DTG_Kidney-failure-end-stage-kidney-disease-dental-considerations_topic_1#c_DTG_Kidney-failure-end-stage-kidney-disease-dental-considerations_topic_1",
    },
    {
      title: "Oral pigmentation",
      link: "/viewTopic?etgAccess=true&guidelinePage=Oral%20and%20Dental&topicfile=c_DTG_Oral-pigmentation_topic_1&guidelinename=auto&sectionId=c_DTG_Oral-pigmentation_topic_1#c_DTG_Oral-pigmentation_topic_1",
    },
  ],
};

export const painandanalgesia = {
  onClickProps: "Pain_and_Analgesia",
  popularTopics: [
    {
      title: "Procedural sedation and analgesia",
      link: "/viewTopic?etgAccess=true&guidelinePage=Pain%20and%20Analgesia&topicfile=procedural-sedation-analgesia",
    },
    {
      title: "Psychological techniques for managing pain",
      link: "/viewTopic?etgAccess=true&guidelinePage=Pain%20and%20Analgesia&topicfile=psychological-techniques-pain",
    },
    {
      title: "General principles of chronic pain management",
      link: "/viewTopic?etgAccess=true&guidelinePage=Pain%20and%20Analgesia&topicfile=general-principles-chronic-pain-management",
    },
    {
      title: "Physical activity and managing chronic pain",
      link: "/viewTopic?etgAccess=true&guidelinePage=Pain%20and%20Analgesia&topicfile=physical-activity-chronic-pain",
    },
    {
      title: "Social connection and chronic pain",
      link: "/viewTopic?etgAccess=true&guidelinePage=Pain%20and%20Analgesia&topicfile=social-connection-chronic-pain",
    },
    {
      title: "Pain associated with shingles (herpes zoster)",
      link: "/viewTopic?etgAccess=true&guidelinePage=Pain%20and%20Analgesia&topicfile=pain-shingles",
    },
    {
      title: "General principles of acute pain management",
      link: "/viewTopic?etgAccess=true&guidelinePage=Pain%20and%20Analgesia&topicfile=general-principles-acute-pain-management",
    },
  ],
};

export const palliativecare = {
  onClickProps: "Palliative_Care",
  popularTopics: [
    {
      title: "Multimorbidity and frailty in palliative care",
      link: "/viewTopic?etgAccess=true&guidelinePage=Palliative%20Care&topicfile=c_PCG_Multimorbidity-and-frailty-in-palliative-care_topic_1&guidelinename=auto&sectionId=c_PCG_Multimorbidity-and-frailty-in-palliative-care_topic_1#c_PCG_Multimorbidity-and-frailty-in-palliative-care_topic_1",
    },
    {
      title: "Medication management in palliative care",
      link: "/viewTopic?etgAccess=true&guidelinePage=Palliative%20Care&topicfile=palliative-care-overview&guidelinename=auto&sectionId=Medication_management_in_palliative_care#Medication_management_in_palliative_care",
    },
    {
      title:
        "Principles of palliative care for patients with common life-limiting illnesses",
      link: "/viewTopic?etgAccess=true&guidelinePage=Palliative%20Care&topicfile=palliative-care-overview&guidelinename=auto&sectionId=Principles_of_palliative_care_for_patients_with_common_life-limiting_illnesses#Principles_of_palliative_care_for_patients_with_common_life-limiting_illnesses",
    },
    {
      title: "Decision-making and ethical challenges in palliative care",
      link: "/viewTopic?etgAccess=true&guidelinePage=Palliative%20Care&topicfile=c_PCG_Decision-making-and-ethical-challenges-in-palliative-care_topic_1&guidelinename=auto&sectionId=c_PCG_Decision-making-and-ethical-challenges-in-palliative-care_topic_1#c_PCG_Decision-making-and-ethical-challenges-in-palliative-care_topic_1",
    },
    {
      title: "Principles of care in the last days of life",
      link: "/viewTopic?etgAccess=true&guidelinePage=Palliative%20Care&topicfile=c_PCG_Principles-of-care-in-the-last-days-of-life_topic_1&guidelinename=auto&sectionId=c_PCG_Principles-of-care-in-the-last-days-of-life_topic_1#c_PCG_Principles-of-care-in-the-last-days-of-life_topic_1",
    },
    {
      title: "Advance care planning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Palliative%20Care&topicfile=c_PCG_Advance-care-planning_topic_1&guidelinename=auto&sectionId=c_PCG_Advance-care-planning_topic_1#c_PCG_Advance-care-planning_topic_1",
    },
  ],
};

export const psychotropic = {
  onClickProps: "Psychotropic",
  popularTopics: [
    {
      title: "Personality disorder",
      link: "/viewTopic?etgAccess=true&guidelinePage=Psychotropic&topicfile=personality-disorder",
    },
    {
      title: "Principles of treating psychoses including schizophrenia",
      link: "/viewTopic?etgAccess=true&guidelinePage=Psychotropic&topicfile=principles-treating-psychoses",
    },
    {
      title: "Stopping an antidepressant",
      link: "/viewTopic?etgAccess=true&guidelinePage=Psychotropic&topicfile=stopping-antidepressants",
    },
    {
      title: "Approach to managing acute behavioural disturbance",
      link: "/viewTopic?etgAccess=true&guidelinePage=Psychotropic&topicfile=approach-acute-behavioural-disturbance",
    },
    {
      title: "First episode of psychosis",
      link: "/viewTopic?etgAccess=true&guidelinePage=Psychotropic&topicfile=first-episode-psychosis",
    },
    {
      title: "Perinatal depression",
      link: "/viewTopic?etgAccess=true&guidelinePage=Psychotropic&topicfile=perinatal-depression",
    },
    {
      title: "Overview of anxiety and associated disorders",
      link: "/viewTopic?etgAccess=true&guidelinePage=Psychotropic&topicfile=overview-anxiety-disorders",
    },
    {
      title: "Jet lag",
      link: "/viewTopic?etgAccess=true&guidelinePage=Psychotropic&topicfile=jet-lag",
    },
    {
      title:
        "Informed consent and shared decision making for a person with a psychiatric disorder",
      link: "/viewTopic?etgAccess=true&guidelinePage=Psychotropic&topicfile=informed-consent-shared-decision-making",
    },
  ],
};

export const respiratory = {
  onClickProps: "Respiratory",
  popularTopics: [
    {
      title: "Inhalational drug delivery devices",
      link: "/viewTopic?etgAccess=true&guidelinePage=Respiratory&topicfile=inhalational-drug-delivery-devices",
    },
    {
      title: "Pulmonary function testing",
      link: "/viewTopic?etgAccess=true&guidelinePage=Respiratory&topicfile=fitness-for-surgery&guidelinename=Respiratory&sectionId=toc_d1e202#toc_d1e155",
    },
    {
      title: "Periprocedural management of patients with respiratory disease",
      link: "/viewTopic?etgAccess=true&guidelinePage=Respiratory&topicfile=fitness-for-surgery",
    },
    {
      title: "Allergic bronchopulmonary aspergillosis",
      link: "/viewTopic?etgAccess=true&guidelinePage=Respiratory&topicfile=allergic-bronchopulmonary-aspergillosis",
    },
    {
      title: "Thunderstorm asthma",
      link: "/viewTopic?etgAccess=true&guidelinePage=Respiratory&topicfile=thunderstorm-asthma",
    },
    {
      title: "Bronchiectasis",
      link: "/viewTopic?etgAccess=true&guidelinePage=Respiratory&topicfile=bronchiectasis",
    },
  ],
};

export const rheumatology = {
  onClickProps: "Rheumatology",
  popularTopics: [
    {
      title: "Clinical assessment of musculoskeletal symptoms in adults",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Clinical-assessment-of-musculoskeletal-symptoms-in-adults_topic_1&guidelinename=auto&sectionId=c_RHG_Clinical-assessment-of-musculoskeletal-symptoms-in-adults_topic_1#c_RHG_Clinical-assessment-of-musculoskeletal-symptoms-in-adults_topic_1",
    },
    {
      title: "Overview of limb conditions",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Overview-of-limb-conditions_topic_1&guidelinename=auto&sectionId=c_RHG_Overview-of-limb-conditions_topic_1#c_RHG_Overview-of-limb-conditions_topic_1",
    },
    {
      title: "Antiphospholipid syndrome",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Antiphospholipid-syndrome_topic_1&guidelinename=auto&sectionId=c_RHG_Antiphospholipid-syndrome_topic_1#c_RHG_Antiphospholipid-syndrome_topic_1",
    },
    {
      title: "Immunoglobulin G4-related disease",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Immunoglobulin-G4-related-disease_topic_1&guidelinename=auto&sectionId=c_RHG_Immunoglobulin-G4-related-disease_topic_1#c_RHG_Immunoglobulin-G4-related-disease_topic_1",
    },
    {
      title: "Principles of immunomodulatory drug use",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Principles-of-immunomodulatory-drug-use_topic_1&guidelinename=auto&sectionId=c_RHG_Principles-of-immunomodulatory-drug-use_topic_1#c_RHG_Principles-of-immunomodulatory-drug-use_topic_1",
    },
    {
      title:
        "Clinical assessment of musculoskeletal symptoms in children and adolescents", // title is not exactly the same as spreadsheet
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Clinical-assessment-musculoskeletal-children-and-adolescent_topic_1&guidelinename=auto&sectionId=c_RHG_Clinical-assessment-musculoskeletal-children-and-adolescent_topic_1#c_RHG_Clinical-assessment-musculoskeletal-children-and-adolescent_topic_1",
    },
    {
      title: "Upper limb conditions / Subacromial pain syndrome",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Subacromial-pain-syndrome_topic_1&guidelinename=auto&sectionId=c_RHG_Subacromial-pain-syndrome_topic_1#c_RHG_Subacromial-pain-syndrome_topic_1",
    },
    {
      title: "Lower limb conditions / Acute knee injuries",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Acute-knee-injuries_topic_1&guidelinename=auto&sectionId=c_RHG_Acute-knee-injuries_topic_1#c_RHG_Acute-knee-injuries_topic_1",
    },
    {
      title: "Overview of inflammatory connective tissue diseases",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Overview-of-inflammatory-connective-tissue-diseases_topic_1&guidelinename=auto&sectionId=c_RHG_Overview-of-inflammatory-connective-tissue-diseases_topic_1#c_RHG_Overview-of-inflammatory-connective-tissue-diseases_topic_1",
    },
    {
      title: "Transition of adolescents to adult rheumatology management",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Transition-of-adolescents-to-adult-rheumatology-management_topic_1&guidelinename=auto&sectionId=c_RHG_Transition-of-adolescents-to-adult-rheumatology-management_topic_1#c_RHG_Transition-of-adolescents-to-adult-rheumatology-management_topic_1",
    },
    {
      title: "Whiplash-associated disorder",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_Whiplash-associated-disorder_topic_1&guidelinename=auto&sectionId=c_RHG_Whiplash-associated-disorder_topic_1#c_RHG_Whiplash-associated-disorder_topic_1",
    },
    {
      title: "JIA-associated uveitis",
      link: "/viewTopic?etgAccess=true&guidelinePage=Rheumatology&topicfile=c_RHG_JIA-associated-uveitis_topic_1&guidelinename=auto&sectionId=c_RHG_JIA-associated-uveitis_topic_1#c_RHG_JIA-associated-uveitis_topic_1",
    },
  ],
};

export const sexualandreproductivehealth = {
  onClickProps: "Sexual_and_Reproductive_Health",
  popularTopics: [
    {
      title: "Infertility",
      link: "/viewTopic?etgAccess=true&guidelinePage=Sexual%20and%20Reproductive%20Health&topicfile=infertility",
    },
    {
      title: "Medical abortion",
      link: "/viewTopic?etgAccess=true&guidelinePage=Sexual%20and%20Reproductive%20Health&topicfile=medical-abortion",
    },
    {
      title: "Male androgen deficiency",
      link: "/viewTopic?etgAccess=true&guidelinePage=Sexual%20and%20Reproductive%20Health&topicfile=androgen-deficiency",
    },
    {
      title: "Erectile dysfunction",
      link: "/viewTopic?etgAccess=true&guidelinePage=Sexual%20and%20Reproductive%20Health&topicfile=erectile-dysfunction",
    },
    {
      title: "Sexual pain in females",
      link: "/viewTopic?etgAccess=true&guidelinePage=Sexual%20and%20Reproductive%20Health&topicfile=sexual-pain",
    },
  ],
};

export const toxicologyandtoxinology = {
  onClickProps: "Toxicology_and_Toxinology",
  popularTopics: [
    {
      title: "Nitrous oxide poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=c_TTG_Nitrous-oxide-poisoning_topic_1&guidelinename=auto&sectionId=c_TTG_Nitrous-oxide-poisoning_topic_1#c_TTG_Nitrous-oxide-poisoning_topic_1",
    },
    {
      title: "Tramadol poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=c_TTG_Tramadol-poisoning_topic_1&guidelinename=auto&sectionId=c_TTG_Tramadol-poisoning_topic_1#c_TTG_Tramadol-poisoning_topic_1",
    },
    {
      title: "Apixaban and rivaroxaban poisonings",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=toxicology-apixaban-and-rivaroxaban",
    },
    {
      title: "Novel stimulant drug poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=toxicology-novel-stimulant",
    },
    {
      title: "Button battery ingestion",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=ingestion-button-battery",
    },
    {
      title: "Amanita phalloides mushroom poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=toxinology-amanita-phalloides",
    },
    {
      title: "Ethanol intoxication",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=c_TTG_Ethanol-intoxication_topic_1&guidelinename=auto&sectionId=c_TTG_Ethanol-intoxication_topic_1#c_TTG_Ethanol-intoxication_topic_1",
    },
    {
      title: "Isopropyl alcohol poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=c_TTG_Isopropyl-alcohol-poisoning_topic_1&guidelinename=auto&sectionId=c_TTG_Isopropyl-alcohol-poisoning_topic_1#c_TTG_Isopropyl-alcohol-poisoning_topic_1",
    },
    {
      title: "Tapentadol poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=c_TTG_Tapentadol-poisoning_topic_1&guidelinename=auto&sectionId=c_TTG_Tapentadol-poisoning_topic_1#c_TTG_Tapentadol-poisoning_topic_1",
    },
    {
      title: "Warfarin poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=toxicology-warfarin",
    },
    {
      title: "Superwarfarin poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=toxicology-superwarfarin",
    },
    {
      title: "Novel hallucinogen drug poisoning", // this header is not exactly the same as spreadsheet
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=toxicology-novel-hallucinogenic",
    },
    {
      title: "Rivaroxaban poisoning", // this header is not exactly the same as spreadsheet
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=toxicology-apixaban-and-rivaroxaban",
    },
    {
      title: "Dabigatran poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=toxicology-dabigatran",
    },
    {
      title: "Herbicide poisoning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=what-is-covered-in-toxicology-toxinology&guidelinename=auto&sectionId=c_herbicide_poisoning_head#c_herbicide_poisoning_head",
    },
    {
      title: "Snake bite",
      link: "/viewTopic?etgAccess=true&guidelinePage=Toxicology%20and%20Toxinology&topicfile=toxinology-snake-bite",
    },
  ],
};

export const ulcerandwoundmanagement = {
  onClickProps: "Ulcer_and_Wound_Management",
  popularTopics: [
    {
      title: "Ulcer and wound dressings",
      link: "/viewTopic?etgAccess=true&guidelinePage=Ulcer%20and%20Wound%20Management&topicfile=ulcer-and-wound-dressings",
    },
    {
      title: "Surgical wounds",
      link: "/viewTopic?etgAccess=true&guidelinePage=Ulcer%20and%20Wound%20Management&topicfile=surgical-wounds",
    },
    {
      title: "Factors affecting ulcer and wound healing",
      link: "/viewTopic?etgAccess=true&guidelinePage=Ulcer%20and%20Wound%20Management&topicfile=factors-affecting-ulcer-and-wound-healing",
    },
    {
      title: "Minor burns",
      link: "/viewTopic?etgAccess=true&guidelinePage=Ulcer%20and%20Wound%20Management&topicfile=minor-burns",
    },
    {
      title: "Skin tears",
      link: "/viewTopic?etgAccess=true&guidelinePage=Ulcer%20and%20Wound%20Management&topicfile=skin-tears",
    },
  ],
};

export const wildernessmedicine = {
  onClickProps: "Wilderness_Medicine",
  popularTopics: [
    {
      title: "Heat-related illness",
      link: "/viewTopic?etgAccess=true&guidelinePage=Wilderness%20Medicine&topicfile=c_WMG_Heat_related_illness_topic_1&guidelinename=auto&sectionId=c_WMG_Heat_related_illness_topic_1#c_WMG_Heat_related_illness_topic_1",
    },
    {
      title: "Tick bite",
      link: "/viewTopic?etgAccess=true&guidelinePage=Wilderness%20Medicine&topicfile=c_WMG_Tick_bite_topic_1&guidelinename=auto&sectionId=c_WMG_Tick_bite_topic_1#c_WMG_Tick_bite_topic_1",
    },
    {
      title: "Drowning",
      link: "/viewTopic?etgAccess=true&guidelinePage=Wilderness%20Medicine&topicfile=c_WMG_Drowning_topic_1&guidelinename=auto&sectionId=c_WMG_Drowning_topic_1#c_WMG_Drowning_topic_1",
    },
    {
      title: "Accidental hypothermia",
      link: "/viewTopic?etgAccess=true&guidelinePage=Wilderness%20Medicine&topicfile=c_WMG_Accidental_hypothermia_topic_1&guidelinename=auto&sectionId=c_WMG_Accidental_hypothermia_topic_1#c_WMG_Accidental_hypothermia_topic_1",
    },
    {
      title: "Electrical injury",
      link: "/viewTopic?etgAccess=true&guidelinePage=Wilderness%20Medicine&topicfile=c_WMG_Electrical_injury_topic_1&guidelinename=auto&sectionId=c_WMG_Electrical_injury_topic_1#c_WMG_Electrical_injury_topic_1",
    },
    {
      title: "Diving medicine",
      link: "/viewTopic?etgAccess=true&guidelinePage=Wilderness%20Medicine&topicfile=c_WMG_Diving_medicine_topic_1&guidelinename=auto&sectionId=c_WMG_Diving_medicine_topic_1#c_WMG_Diving_medicine_topic_1",
    },
    {
      title: "Altitude illness",
      link: "/viewTopic?etgAccess=true&guidelinePage=Wilderness%20Medicine&topicfile=c_WMG_Alititude_illness_topic_1&guidelinename=auto&sectionId=c_WMG_Alititude_illness_topic_1#c_WMG_Alititude_illness_topic_1",
    },
    {
      title: "Bites, stings and rashes in the wilderness",
      link: "/viewTopic?etgAccess=true&guidelinePage=Wilderness%20Medicine&topicfile=c_WMG_Bites_stings_and_rashes_in_the_wilderness_topic_1&guidelinename=auto&sectionId=c_WMG_Bites_stings_and_rashes_in_the_wilderness_topic_1#c_WMG_Bites_stings_and_rashes_in_the_wilderness_topic_1",
    },
  ],
};

export const popularTopics = [
  addictionMedicine,
  antibiotic,
  boneandmetabolism,
  cardiovascular,
  dermatology,
  developmentaldisability,
  diabetes,
  fatigue,
  gastrointestinal,
  liverdisorders,
  neurology,
  oralanddental,
  painandanalgesia,
  palliativecare,
  psychotropic,
  respiratory,
  rheumatology,
  sexualandreproductivehealth,
  toxicologyandtoxinology,
  ulcerandwoundmanagement,
  wildernessmedicine,
];
